import React from "react";

import ActaModal from "@/components/ui/ActaModal";
import { Button } from "@/components/ui/button";

export default function InstallationRefusalModal({
  open,
  saving = false,
  reason = "",
  onReasonChange,
  onClose,
  onSubmit,
}) {
  const canSubmit = Boolean(reason.trim()) && !saving;

  return (
    <ActaModal
      open={open}
      onClose={onClose}
      closeDisabled={saving}
      eyebrow="Confirmation client"
      title="Client refuse"
      subtitle="Le dossier reviendra à l’étape À préparer pour pouvoir être corrigé ou supprimé."
      size="sm"
      testId="installation-client-refusal-modal"
      footer={(
        <>
          <Button
            type="button"
            variant="actaSecondary"
            disabled={saving}
            onClick={onClose}
          >
            Annuler
          </Button>

          <Button
            type="button"
            variant="actaDanger"
            disabled={!canSubmit}
            onClick={onSubmit}
            data-testid="installation-client-refusal-submit"
          >
            {saving ? "Enregistrement…" : "Enregistrer le refus"}
          </Button>
        </>
      )}
    >
      <label className="block space-y-2">
        <span className="label-eyebrow block">
          Motif du refus *
        </span>

        <textarea
          value={reason}
          onChange={(event) => onReasonChange?.(event.target.value)}
          disabled={saving}
          rows={4}
          maxLength={1000}
          autoFocus
          data-testid="installation-client-refusal-reason"
          placeholder="Indiquez pourquoi le client refuse."
          className="w-full resize-none rounded-xl border border-[var(--do-border)] bg-[var(--do-bg-solid)] px-3 py-2.5 text-sm outline-none focus:border-[var(--do-accent)] disabled:opacity-60"
        />
      </label>
    </ActaModal>
  );
}
